import React, { useCallback } from 'react'
import { useUpdateLog } from 'utils/log'

import { FormTitleProps } from '../items/FormTitle'
import SwitchLine, { SwitchLineProps } from '../items/SwitchLine'
import BaseGroup from './BaseGroup'

/**
 * 対象がSwitchGroupProps型かチェックする
 * @param target チェック対象
 */
export const isSwitchGroupProps = (target: any): target is SwitchGroupProps => {
  return target.switch !== undefined && target.title !== undefined
}

/**
 * スイッチグループ
 */
const SwitchGroup: React.FC<SwitchGroupProps> = (props) => {
  const toggleSwitch = useCallback((): void => {
    const state = { ...props.switch }
    state.isSwitched = !state.isSwitched
    props.setSwitch && props.setSwitch(state)
  }, [props])

  useUpdateLog(
    props.title,
    {
      title: props.title,
      isRequired: props.isRequired,
      switch: props.switch,
    },
    [props]
  )

  return (
    <BaseGroup
      isRequired={props.isRequired}
      title={props.title}
      description={props.description}
      hideTitle={props.hideTitle}
    >
      <SwitchLine
        {...props.switch}
        onClick={(): void => {
          toggleSwitch()
        }}
      />
    </BaseGroup>
  )
}

export type SwitchGroupProps = FormTitleProps & {
  switch: SwitchLineProps
  formName: string
  setSwitch?: (sampleSwitch: SwitchLineProps) => void
}

export default React.memo<SwitchGroupProps>(SwitchGroup)
